<template>
  <!-- 公司账号管理 --账号管理 -->
  <div class="accountTem">
    <div class="searchWarp1">
      <div>
        <div class="searchBox">
          <el-input v-model.trim="searchObj.userName" :placeholder="$t('company.Name')+' / '+$t('company.Account')" class="input-with-select" clearable @keydown.enter="search">
            <el-button slot="append" icon="el-icon-search" @click="search" />
          </el-input>
        </div>
        <el-button icon="el-icon-plus" :title="$t('titles.addAccount')" type="primary" @click="openAccountPop(true)" />
      </div>
      <span class="fr c_name" :title="activeCompanyInfo.companyName">{{ $t('company.Companyname') }}：{{ activeCompanyInfo.companyName }}</span>
    </div>
    <div class="tableAndPaginat">
      <div v-loading="loading">
        <el-table ref="accountTable" border="" :data="accountTableList" class="accountTable">
          <el-table-column prop="userRealName" :label="$t('company.Name')" align="center" min-width="15%" />
          <el-table-column prop="userLoginName" :label="$t('company.Account')" align="center" min-width="15%" />
          <el-table-column prop="companyName" :label="$t('BondOrUpdateDevice.OwnedCompany')" align="center" min-width="23%" />
          <!-- <el-table-column prop="userPhone" :label="$t('account.phone')" align='center'> </el-table-column> -->
          <el-table-column prop="userEmail" :label="$t('company.Email')" align="center" min-width="23%" />

          <el-table-column prop="guestFlag" :label="$t('company.Guest')" align="center" min-width="10%">
            <template slot-scope="scope">
              <i v-if="scope.row.guestFlag" style="color:red">{{ $t('allDeviceDetail.Yes') }}</i>
              <i v-if="!scope.row.guestFlag" style="color:">{{ $t('allDeviceDetail.no') }}</i>
            </template>
          </el-table-column>

          <el-table-column prop="" :label="$t('yhubReport.Operating')" align="center" min-width="14%">
            <template slot-scope="scope">
              <div class="opration">
                <i class="el-icon-edit" :title="$t('titles.edit')" @click="openAccountPop(false,scope.row)" />
                <i class="el-icon-delete" :title="$t('titles.delete')" @click="deleteCompany(scope.row)" />
                <i class="el-icon-lock" :title="$t('titles.editPassword')" @click="openAccountPop(false,scope.row,'editPassword')" />
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination-container">
          <el-pagination v-if="listQuery.pageshow" :page-size="listQuery.pageSize" :total="listQuery.total" background layout="prev, pager, next, total" @current-change="handleCurrentChange" />
        </div>
      </div>
    </div>

    <el-dialog :close-on-click-modal="false" :visible.sync="addAccountPopShow" width="50%">
      <addEditAccountTem v-if="addAccountPopShow" :user-pop-info="userPopInfo" :is-add="isAdd" :is-edit-password="isEditPassword" :add-account-pop-show="addAccountPopShow" :role-options="roleOptions" :drm-module-options="drmModuleOptions" @closePop="closePop" />
    </el-dialog>
  </div>
</template>

<script>
import { pageList, deleteById2, getCompanyById } from '@/api/company'
import { getInfo } from '@/api/user'
import addEditAccountTem from './addEditAccountTem'
import { mapState, mapMutations, mapGetters } from 'vuex'
import i18n from '@/i18n'
export default {
  components: { addEditAccountTem },
  props: ['activeCompanyId', 'activeCompanyInfo', 'roleOptions'],
  data() {
    return {
      loading: true,
      listQuery: {// 分页
        pageSize: 10,
        total: 0,
        pageNum: 1,
        pageshow: true
      },
      companyInfo: {
        companyName: '',
        companyId: ''
      },
      searchObj: {
        userName: ''
      },
      companyId: this.$store.state.companyId,
      accountTableList: [],
      addAccountPopShow: false,
      isAdd: true,
      userPopInfo: {
        companyId: null,
        companyName: null,
        userLoginName: null,
        userPassword: null,
        userRealName: null,
        userEmail: null,
        userPhone: null,
        id: null,
        userPassword1: null,
        userPassword2: null,
        guestFlag: false,
        roleIds: [],
        drmModule: []
      },
      isEditPassword: false // 是否是更改密码
    }
  },
  computed: {
    ...mapGetters(['getUserInfo']),
    ...mapState([
      'companyOption'
    ]
    ),
    currentId() {
      return this.activeCompanyId
    },
    drmModuleOptions() {
      return [
        {
          value: 1,
          label: i18n.t('company.DesktopMagt'), // '桌面管理',
          children: [
            {
              value: 'yhub',
              label: i18n.t('AllDevices.BatteryMonitor') // '电池监控器'
            },
            // {
            //   value: 'lithium',
            //   label: i18n.t('AllDevices.LithiumBattery') // '锂电池'
            // },
            {
              value: 'charger',
              label: i18n.t('AllDevices.charger') // '充电器'
            },
            {
              value: 'kisae',
              label: 'KISAE'
            },
            {
              value: 'Energy',
              label: 'Energy Management'
            },
            {
              value: 'lease',
              label: i18n.t('company.LeaseMagt') // '租赁管理'
            },
            {
              value: 'GPDEnergy',
              label: 'GPD Energy Management'
            }
          ]
        }
        /* {
          value: 2,
          label: i18n.t('company.BasicModule'), // '基础模块',
          children: [
            {
              value: 'deviceMsg',
              label: i18n.t('company.DeviceMsg') // '设备消息'
            },
            {
              value: 'accountMagt',
              label: i18n.t('company.AccountMagt') // '账号管理'
            },
            {
              value: 'deviceDis',
              label: i18n.t('company.deviceDis') // '设备分布'
            }
          ]
        } */
      ]
    }
  },
  watch: {
    currentId(val) {
      if (val) {
        this.listQuery.pageNum = 1
        this.queryList()// 初始化
      }
    }
  },
  mounted() {
    this.queryList()// 初始化
  },
  methods: {
    ...mapMutations(['setUserInfo']),
    getCompanyInfo() { // 获取公司信息
      if (!this.currentId) return
      getCompanyById({ id: this.currentId }).then(res => {
        if (res.resultCode == 1001) {
          this.companyInfo = res.resultModel || {}
        } else {
          this.$message({
            type: 'error',
            message: res.resultMessage
          })
        }
      })
    },
    queryList() { // 初始化
      if (!this.currentId) return
      this.loading = true
      var param = {
        companyId: this.currentId,
        'subaccountsFlag': false,
        // userRealName: this.searchObj.userName,
        userLoginName: this.searchObj.userName,
        'pageNum': this.listQuery.pageNum, // 分页--选中某一页
        'pageSize': this.listQuery.pageSize // 分页--每一页的列表的行数 10 20 50
      }
      pageList(param).then(res => {
        this.loading = false
        if (res.resultCode == 1001 && res.resultModel) {
          this.accountTableList = res.resultModel.list
          this.listQuery.total = res.resultModel.total
          console.log(this.accountTableList)
        } else {
          this.accountTableList = []
          this.$message({
            type: 'error',
            message: res.resultMessage
          })
        }
      })
    },
    handleCurrentChange(val, e) { // 选中某一页
      this.listQuery.pageNum = val
      this.queryList(false)
    },
    search() { // 搜索
      this.listQuery.pageNum = 1
      this.listQuery.pageshow = false
      this.queryList()
      this.$nextTick(() => {
        this.listQuery.pageshow = true
      })
    },
    openAccountPop(val, item, c) { // 新增/编辑用户信息弹窗--打开
      this.addAccountPopShow = true
      this.isAdd = val
      this.isEditPassword = c == 'editPassword'
      if (val) { // 新增
        for (var attr in this.userPopInfo) {
          if (attr == 'guestFlag') {
            continue
          }
          this.userPopInfo[attr] = null
          this.userPopInfo.companyName = this.activeCompanyInfo.companyName
          this.userPopInfo.companyId = this.activeCompanyInfo.id
        }
      } else { // 编辑
        for (var attr in this.userPopInfo) this.userPopInfo[attr] = item[attr]
        this.userPopInfo.companyName = this.activeCompanyInfo.companyName
        this.userPopInfo.userPassword1 = this.userPopInfo.userPassword2 = null
        item.drmModuleArr = ['yhub', 'deviceMsg', 'deviceDis']
        var rolesArr = []
        if (item.roleInfos) {
          if (item.roleInfos.indexOf(',') > -1) { rolesArr = item.roleInfos.split(',') } else { rolesArr.push(item.roleInfos) }
          this.userPopInfo.roleIds = []
          rolesArr.forEach((m, mi) => {
            this.userPopInfo.roleIds.push(Number(m.split('##')[0]))
          })
        } else {
          this.userPopInfo.roleIds = []
        }
        if (item.allModules) {
          this.userPopInfo.drmModule = []
          JSON.parse(item.allModules).forEach(v => {
            this.drmModuleOptions.forEach((m, mi) => {
              m.children.forEach(n => {
                if (v == n.value) {
                  this.userPopInfo.drmModule.push([m.value, n.value])
                }
              })
            })
          })
        } else {
          this.userPopInfo.drmModule = []
        }
        console.log('this.userPopInfo.drmModule', this.userPopInfo.drmModule)
      }
    },
    closePop(val) { // /新增/编辑用户信息弹窗--关闭
      this.addAccountPopShow = false
      if (val == 'needInt') this.queryList()// 初始化
    },
    deleteCompany(item) { // 删除用户
      this.$confirm(this.$t('company.Deletethisaccount'), '', {// 是否删除该账号？
        confirmButtonText: i18n.t('button.Confirm'), // '确定'
        cancelButtonText: i18n.t('button.Cancel'),
        type: 'warning'
      }).then(() => {
        deleteById2({ 'id': item.id }).then(res => {
          if (res.resultCode == '1001') {
            this.successFn()// 弹窗提交成功后，调userInfoV3，并存储数据，刷新页面
          } else {
            this.$message({
              type: 'error',
              message: res.resultMessage
            })
          }
        })
      }).catch(() => { })
    },
    successFn() { // 弹窗提交成功后，调userInfoV3，并存储数据，刷新页面
      this.$message({
        message: this.$t('lease.Succeed'),
        type: 'success'
      })
      getInfo(this.getToken).then(resp => {
        if (resp.resultCode == 1001) {
          this.setUserInfo(resp.resultModel)
          // console.log(this.$store)
          this.queryList()// 初始化
        }
      })
    }

  }
}
</script>

<style lang="scss" scoped>
.el-icon-plus {
  margin-right: 10px;
}
.accountTem {
  margin: 0 auto;
  height: calc(100% - 40px);
  .tableAndPaginat{
    height: calc(100% - 50px);
    overflow-y: auto;
    &>div{
      // height:100%;
      width:100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
  }
  .searchWarp1 {
    border-radius: 10px;
    margin-bottom: 15px;
    display: flex;
    justify-content: space-between;
    width: 100%;
    &>div{
      width:50%;
      display: flex;
      align-items: center;
      .el-button{
        margin-left: 10px;
      }
    }
    .c_name {
      font-size: 16px;
      line-height: 40px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin-left: 20px;
    }
  }
  .accountTable {
    margin-top: 10px;
  }
  .opration {
    i{
      font-size: 20px;
      cursor: pointer;
    }
    i:nth-of-type(2) {
      margin: 0 5px;
    }
  }
}
</style>
